module.exports = __webpack_public_path__ + "static/media/qrcode.6d183084.svg";